<template>
    <div class="terms ql-editor">
        <span v-html="term_template.translation.body"></span>
    </div>
</template>

<script>
export default {
    name: 'StudentTerms',
    props: ['term_template'],
};
</script>

<style>
.terms {
    text-align: center;
    margin-top: 35px;
}
</style>
